import { get } from 'lodash';
import React from 'react';
import { FieldArray, useFormikContext } from 'formik';

import { LayoutBox, Flex, Delimiter, Button } from 'src/kit';
import { Title, AddButton, RemoveButton, FormikSubmitButton } from '@src/features/common';
import { getDefaultExperience } from './validationSchema';
import { Experience } from './Experience';

export default function({ resourcesStore, isAnonymousJob, initialValues, goToNextStep }) {
  const { values, errors, isSubmitting, setFieldValue } = useFormikContext();

  const handleSkip = () => {
    setFieldValue('experiences_attributes', []);
    goToNextStep();
  };

  return (
    <div>
      {Boolean(initialValues.experiences_attributes?.length) && (
        <>
          <Title>Let us know about any relevant jobs/internships you've done recently</Title>
          <Delimiter my={30} />
        </>
      )}
      <FieldArray name="experiences_attributes">
        {arrayHelpers => (
          <div>
            <LayoutBox mb={20} rowGap={50}>
              {values.experiences_attributes.map((experience, index, array) => (
                <Flex key={experience.id || experience.cid}>
                  <Experience
                    resourcesStore={resourcesStore}
                    index={index}
                    experienceValues={get(values, `experiences_attributes.${index}`, {})}
                    errors={errors}
                    setFieldValue={setFieldValue}
                  />
                  {array.length > 1 && <RemoveButton onClick={() => arrayHelpers.remove(index)} />}
                </Flex>
              ))}
            </LayoutBox>
            <AddButton onClick={() => arrayHelpers.push(getDefaultExperience())}>Add work experience</AddButton>
          </div>
        )}
      </FieldArray>
      <Flex justifyContent="flex-end" mr={120}>
        {isAnonymousJob && (
          <Button onClick={handleSkip} mr={20} variant="cancel" size="md">
            Skip
          </Button>
        )}
        <FormikSubmitButton variant="primary" size="md">
          {isSubmitting ? 'Validating' : 'Validate'}
        </FormikSubmitButton>
      </Flex>
    </div>
  );
}
